// extracted by mini-css-extract-plugin
module.exports = {"deleteAni":"Animation_deleteAni__3mMRN"};